import { Market } from "./Market";
import { State } from "./State";
import { SubState } from "./SubState";

export enum AddressType {
  Warehouse = "warehouse",
  Custom = "custom",
  Distributor = "distributor",
  ChangeRequest = "change-request",
  Branch = "market",
  BranchCustom = "market-custom",
}

export type ShippingAlertChannel = "retail" | "on_premise";

export interface ShippingAlertRecipient {
  email: string;
  channels: ShippingAlertChannel[];
}

export interface AddressBaseFields {
  id: string;
  abn: string;
  city: string;
  country: string;
  defaultAttn: string | null;
  isActive: boolean;
  name: string;
  shippingAlertRecipients: ShippingAlertRecipient[];
  phoneNumber: string;
  state: State;
  stateId: number;
  streetAddress1: string;
  streetAddress2: string | null;
  subStateId: number;
  territoryId: number | null;
  warehouse: null;
  zip: string | null;

  // Reyes integration (eligible when sub-state code is CA_RY_ST; see isReyesSubState)
  isForReyes: boolean;
  externalReyesId: string | null;
}
export interface Address extends AddressBaseFields {
  type: `${AddressType}`;
  deactivationNote: string | null;
  deactivatedByName: string | null;
  deactivatedAt: string | null;
  currentUserAttn: string | null;
  hasChangeRequests: boolean;
  subState: SubState;
  market: Market | null;
}
